<template>
<div>
    <v-card color="grey lighten-5" flat>
        <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{baslik}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="this.$route.query.islem == 'ekle'" @click="sorundestekekle()" class="white--text" flat><span class="hidden-sm-and-down">Kaydet </span>
                    <v-icon right dark>add_box</v-icon>
                </v-btn>
                <v-btn v-if="this.$route.query.islem == 'guncelle'" @click="guncelle()" class="white--text" flat><span class="hidden-sm-and-down">Güncelle </span>
                    <v-icon right dark>system_update_alt</v-icon>
                </v-btn>
                <v-menu bottom="">
                    <v-btn slot="activator" dark icon>
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                        <a target="_self" v-bind:href="'#/destek/sorundetay/id?' + 'sorunid=' + this.$route.query.sorunid  + '&islem=guncelle'">
                            <v-list-tile>
                                <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                            </v-list-tile>
                        </a>
                    </v-list>
                </v-menu>
            </v-toolbar>
        </v-flex>

    </v-card>

    <v-layout row="" wrap="">
        <v-flex pa-1 xs12 sm6 md6>
            <v-card class="white--text">
                <v-card color="grey lighten-4" flat="">
                    <v-card-actions>
                        <v-layout justify-space-between column>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md6>
                                        <v-select :items="itemsDestekTip" item-text="Aciklama" item-value="DestekTipID" v-model="destekEkle.DestekTip.DestekTipID" label="Destek Tipi"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                        <tarihim :etiket="'Alış Tarihi'" :detaygizle="false" v-model="destekEkle.DestekBaslangicTarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                        <v-text-field v-model="destekEkle.SaatBaslangic" label="Başlangıç Saati" append-outer-icon="access_time"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md6>
                                        <v-select :items="itemskullanici" item-text="AdSoyad" item-value="UserID" v-model="destekEkle.UserBilgi.UserID" label="Kullanıcı "></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                        <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="destekEkle.DestekBitisTarih" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                        <v-text-field v-model="destekEkle.SaatBitis" label="Bitiş Saati" append-outer-icon="access_time"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md6>
                                        <v-select :items="itemsCozumTip" item-text="Aciklama" item-value="CozumTipID" v-model="destekEkle.CozumTip.CozumTipID" label="Çözüm Tipi"></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 md3>
                                        <v-text-field hide-details="" v-model="destekEkle.FisNo" label="Fiş No"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-card>
            </v-card>
        </v-flex>
        <v-flex pa-1 xs12 sm6 md6>
            <v-layout row wrap>
                <v-flex pa-1 xs12 sm12 md12>
                    <v-card class="white--text">
                        <v-card color="grey lighten-4" flat="">
                            <vue-editor v-model="destekEkle.DestekAciklama" label="Destek"></vue-editor>
                        </v-card>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
    <template>
        <v-card>
            <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
            </v-snackbar>
        </v-card>
    </template>

</div>
</template>

<script>
import auth from '../../../api/auth'
import tarihim from '../customcomp/tarihim'
import {
    VueEditor
} from "vue2-editor"
import router from '../../../router'
export default {
    data() {
        return {

            rules: {
                required: (value) => !!value || 'Gerekli alan.',
            },
            baslik: '',
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            itemskullanici: [],
            itemsDestekTip: [],
            itemsCozumTip: [],
            destekEkle: {
                DestekID: null,
                SorunID: this.$route.query.sorunid,
                DestekTip: {
                    DestekTipID: null,
                    Aciklama: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                DestekBaslangicTarih: null,
                DestekBitisTarih: null,
                DestekAciklama: null,
                FisNo: null,
                CozumTip: {
                    CozumTipID: null,
                    Aciklama: null,
                },
                SaatBaslangic: null,
                SaatBitis: null,
            },

        }
    },
    methods: {

        sorundestekekle: sorundestekekle,
        kullaniciListesi: kullaniciListesi,
        destekTipcek: destekTipcek,
        guncelle: guncelle,
        SaatBaslangic: SaatBaslangic,
        zeroPadding: zeroPadding,
        saatCanli: saatCanli,
        cozumTipCek: cozumTipCek,

    },
    beforeMount: beforeMount,
    components: {
        tarihim,
        VueEditor
    },

}

function saatCanli() {
    if (this.$route.query.islem == 'ekle') {
        setInterval(() => {

            var cd = new Date();

            this.destekEkle.SaatBitis = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
        }, 1000);
    }
}

function SaatBaslangic() {
    var dt = new Date();
    this.destekEkle.SaatBaslangic = zeroPadding(dt.getHours(), 2) + ':' + zeroPadding(dt.getMinutes(), 2) + ':' + zeroPadding(dt.getSeconds(), 2);
}

function zeroPadding(num, digit) {
    var zero = '';
    for (var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}

function beforeMount() {
    this.kullaniciListesi()
    this.destekTipcek()
    this.cozumTipCek()
    if (this.$route.query.islem == 'ekle') {
        this.baslik = 'Destek Ekle '
    } else if (this.$route.query.islem == 'guncelle') {
        this.baslik = 'Destek Güncelle'
        var params = {
            SupportID: this.$route.query.supportid
        }
        this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportLoad', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.destekEkle = response.body
            this.destekEkle.SaatBaslangic = this.destekEkle.SaatBaslangic.substring(11, 19)
            this.destekEkle.SaatBitis = this.destekEkle.SaatBitis.substring(11, 19)
        }, (response) => {
            if (response.status === 0) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
            } else {
                this.text1 = response.statusText
                this.snackbar = true
            }
        })
    }
    this.SaatBaslangic()
    this.saatCanli()

}

function sorundestekekle() {
    var params = this.destekEkle

    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true

        this.$router.push('/destek/sorundetay/id?' + 'sorunid=' + this.$route.query.sorunid + '&islem=guncelle')
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true

        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function guncelle() {

    var params = {

        DestekID: this.$route.query.supportid,
        SorunID: this.destekEkle.SorunID,
        DestekTip: {
            DestekTipID: this.destekEkle.DestekTip.DestekTipID,
            Aciklama: this.destekEkle.DestekTip.Aciklama,
        },
        UserBilgi: {
            UserID: this.destekEkle.UserBilgi.UserID,
            Email: this.destekEkle.UserBilgi.Email,
            AdSoyad: this.destekEkle.UserBilgi.AdSoyad,
        },
        DestekBaslangicTarih: this.destekEkle.DestekBaslangicTarih,
        DestekBitisTarih: this.destekEkle.DestekBitisTarih,
        DestekAciklama: this.destekEkle.DestekAciklama,
        FisNo: this.destekEkle.FisNo,
        CozumTip: {
            CozumTipID: this.destekEkle.CozumTip.CozumTipID,
            Aciklama: this.destekEkle.CozumTip.Aciklama,
        },
        SaatBaslangic: this.destekEkle.SaatBaslangic,
        SaatBitis: this.destekEkle.SaatBitis,
    }

    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.text1 = response.body.ResponseMessage
        this.snackbar = true
        this.$router.push('/destek/index/')
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function kullaniciListesi() {
    var response = JSON.parse(window.localStorage.getItem('response'))
    var params = {

        Email: response.Email
    }
    this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemskullanici = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function destekTipcek() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsDestekTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function cozumTipCek() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SolutionTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsCozumTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}
</script>

<style>
</style>
